import React from "react";
import { Button, Container } from "react-bootstrap";
import { Breadcrumb, LoginHeader } from "../../components";

function ApplyForFinancing() {

    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Apply For Financing',
        },
    ];

    return (
        <>
            <LoginHeader />
            <div className="main-content aboutPage tipOfMonthPage">
                {/* page content */}
                <div className="pageContent">
                    <Container className="container-lg">
                        <Breadcrumb title="Apply For Financing" breadcrumb={breadcrumb} />
                        <div className="p-30 bg-white br-10 tipOfMonthPage_finance cardHeight">
                            <h3 className="aboutPage_title text-850 mt-0">Financing Options Available</h3>
                            <div className="d-flex flex-wrap">
                                <Button variant="primary" className="me-2">WELLS FARGO</Button>
                                <Button className="btn-info">ALLY LENDING</Button>
                            </div>
                        </div>
                    </Container>
                </div>
            </div>
        </>
    );
}

export default ApplyForFinancing;